import type { Extension } from "@tiptap/react";
import Placeholder from "@tiptap/extension-placeholder";
import type { EditorProps } from "../types";

interface Args {
  placeholder: EditorProps["placeholder"];
}

export const CustomPlaceholderExtension = (args: Args): Extension => {
  const { placeholder } = args;

  return Placeholder.configure({
    placeholder: ({ editor }) => {
      if (!editor.isEditable) return "";

      if (placeholder) {
        if (typeof placeholder === "string") return placeholder;

        return placeholder(editor.isFocused, editor.getHTML());
      }

      return "";
    },
    includeChildren: true
  });
};
